import type { Grade } from './types';

/** Product defaults, not a measured personal forgetting curve. */
export const INTERVAL_DAYS = [1, 3, 7, 14, 30, 60] as const;
export const MAX_STAGE = INTERVAL_DAYS.length - 1;
const DAY = 86_400_000;
const AGAIN_MS = 10 * 60_000;

export interface SrsState {
  stage: number;
  dueAt: number;
  reviews: number;
}

export function newSrsState(now = Date.now()): SrsState {
  return { stage: 0, dueAt: now, reviews: 0 };
}

/**
 * again → 10 minutes and back to stage 0
 * hard  → 1 day, step back one stage
 * good  → current stage interval, then advance
 */
export function schedule(state: SrsState, grade: Grade, now = Date.now()): SrsState {
  const stage = Math.max(0, Math.min(MAX_STAGE, Math.floor(state.stage || 0)));
  const reviews = (state.reviews || 0) + 1;
  switch (grade) {
    case 'again':
      return { stage: 0, dueAt: now + AGAIN_MS, reviews };
    case 'hard':
      return { stage: Math.max(0, stage - 1), dueAt: now + DAY, reviews };
    case 'good':
      return { stage: Math.min(MAX_STAGE, stage + 1), dueAt: now + INTERVAL_DAYS[stage]! * DAY, reviews };
    default:
      throw new Error(`Invalid grade: ${String(grade)}`);
  }
}

export function isDue(state: Pick<SrsState, 'dueAt'>, now = Date.now()): boolean {
  return state.dueAt <= now;
}

export type Mastery = 'new' | 'learning' | 'mastered';

export function mastery(state: Pick<SrsState, 'stage' | 'reviews'>): Mastery {
  if (!state.reviews) return 'new';
  return state.stage >= 3 ? 'mastered' : 'learning';
}
